import { render, staticRenderFns } from "./DealProductsTable.vue?vue&type=template&id=6b2b3880&scoped=true&lang=pug&"
import script from "./DealProductsTable.vue?vue&type=script&lang=js&"
export * from "./DealProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./DealProductsTable.vue?vue&type=style&index=0&id=6b2b3880&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b3880",
  null
  
)

export default component.exports